import { Anchor, Box, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { paths } from "@/config/paths";

import type { MarketCar } from "@/types/market";
import type { FC, RefObject } from "react";

interface Props {
  resultsContainerRef: RefObject<HTMLDivElement | null>;
  filteredResults: MarketCar[];
  visibleResultsCount: number;
  loadMoreRef: RefObject<HTMLDivElement | null>;
  close: () => void;
}

const SearchFilteredResults: FC<Props> = ({
  resultsContainerRef,
  filteredResults,
  visibleResultsCount,
  loadMoreRef,
  close,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Text size="sm" mt="lg" style={{ flexShrink: 0 }}>
        {t("header.results")}:
      </Text>
      <Box
        ref={resultsContainerRef}
        mt="md"
        style={{
          maxHeight: "400px",
          overflowY: "auto",
          minHeight: 0,
        }}
      >
        {filteredResults.slice(0, visibleResultsCount).map((car: MarketCar) => (
          <Box key={`marketCar_${car.id}`}>
            <Anchor
              size="sm"
              component={Link}
              to={paths.app.markets.car.getHref(car.id)}
              onClick={close}
            >
              {car.make_name} {car.model_name} {car.variant}
            </Anchor>
            <Text c="gray" fz="sm">
              {car.production_years}
            </Text>
          </Box>
        ))}
        {visibleResultsCount < filteredResults.length && <Box ref={loadMoreRef} h={1} />}
      </Box>
    </>
  );
};

export default SearchFilteredResults;
